import React from 'react';

export default class Detail extends React.Component {
  render(){
    const data = this.props.data;
    const img = data.thumb ? <div className='box-img-ex'><img src={data.thumb} /></div> : null;
    const obs = data.observacoes ? <div className='box-obs-ex'>{data.observacoes}</div> : null;

    let videos = data.videos.map((value, i) =>
        <div href="#" key={i} className='video-ex'>
          <div className='video-name-ex'>{value.nome}</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${value.video}?autoplay=1&loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
          <div>{value.observacoes}</div>
        </div>
      );

    return(
      <div>
        <div className='exercicio-nome'>{data.nome}</div>
        {img}
        <div className='videos-wrapper-ex'>
          {videos}
        </div>
        {obs}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/exercicios/Detail.js